const apiUrl = process.env.REACT_APP_API_URL;

export const DeleteSprint = async (idSprint: string) => {
    try {
        const response = await fetch(`${apiUrl}:8061/projectes/sprints/${idSprint}`, {
            method: 'DELETE',
        });
        return response.status === 200;
    } catch (error) {
        console.log('Error al eliminar el sprint:', error);
        return false;
    }
};
